import "../App.css";

export default function Home() {
  return (
    <div className="page home-page">
      <h1 className="title">Welcome to my page!</h1>
      <p className="welcome-description">
        This web application is a combination of portfolio's so I could practice with programming javascript/typescript and react. Feel free to look around, check out my photo's, recipes or code projects. You can also see the source code for this application on Github.
      </p>
    </div>
  );
}